<template>
  <div :class="classList" v-if="active">
    <slot />
  </div>
</template>

<script>
import Tabs from './Tabs.vue'

export default {
  meta: {
    parent: 'Tabs',
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    postTitleComponent: {
      type: [Object, Function],
      default: null,
    },
  },
  data: () => ({
    active: false,
  }),
  computed: {
    classList() {
      const list = [
        'aha-tab-item',
        { active: this.active },
      ]

      if (typeof this.attached === 'string') {
        list.push(this.attached)
      }

      return list
    },
  },
  mounted() {
    try {
      this.findParent().addTab(this)
    } catch (e) {
      throw new Error('aha-tab-item was placed outside of aha-tabs component')
    }
  },
  methods: {
    findParent() {
      let parent = this.$parent

      while (parent.$options.name !== Tabs.name) {
        parent = parent.$parent
      }

      return parent
    },
    open() {
      this.active = true
    },
    close() {
      this.active = false
    },
  },
}
</script>

<style lang="scss" scoped>
  .aha-tab-item {
    @apply w-full;
  }
</style>
